module.exports = __webpack_public_path__ + "img/estrella.2de265cb.svg";